'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product12__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.mJ;
      break;
    }
    case 1: {
      return $thiz.mN;
      break;
    }
    case 2: {
      return $thiz.mO;
      break;
    }
    case 3: {
      return $thiz.mP;
      break;
    }
    case 4: {
      return $thiz.mQ;
      break;
    }
    case 5: {
      return $thiz.mR;
      break;
    }
    case 6: {
      return $thiz.mS;
      break;
    }
    case 7: {
      return $thiz.mT;
      break;
    }
    case 8: {
      return $thiz.mU;
      break;
    }
    case 9: {
      return $thiz.mK;
      break;
    }
    case 10: {
      return $thiz.mL;
      break;
    }
    case 11: {
      return $thiz.mM;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 11)"));
    }
  }
}
export { $f_s_Product12__productElement__I__O as $f_s_Product12__productElement__I__O };
